/** @format */

export function clear() {
  this.setState(defaultState);
}
